import { useSelectedTeam } from "features/team-settings/hooks";

/**
 * Returns whether agent work features should be shown, plus a loading
 * flag to avoid premature redirects before team data has loaded.
 */
export const useAgentWorkFlag = (): {
  enabled: boolean;
  isLoading: boolean;
} => {
  const { selectedTeam, isAgentWorkEnabled } = useSelectedTeam();
  const isLoading = selectedTeam === undefined;
  return { enabled: isAgentWorkEnabled, isLoading };
};
